













































import { Component, Vue } from 'vue-property-decorator'
import { index, login, confirmed } from '@/api/ws_accounts'

@Component({
  components: {}
})

export default class extends Vue {
  credentials: Record<string, any> = {
    wId: null,
    qrCodeUrl: null
  }

  dialogVisible = false

  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'name', label: 'Name', slot: true },
      { prop: 'w_id', label: 'wId' },
      { prop: 'wc_id', label: 'wcId' },
      { prop: 'w_account', label: 'wAccount' },
      { prop: 'status', label: 'status', slot: true },
      { prop: 'created_at', label: 'Login time', width: 150 }
    ]
  }

  async onGetLoginQrcode () {
    this.credentials = (await login()).data
    this.dialogVisible = true
  }

  async onConfirmedLogin () {
    await confirmed(this.credentials)
    const el: any = this.$refs.table
    el.getItems(1)
    this.$message.success('User has been login')
  }
}
